import { Page404Styled } from "./styles";
import { Container } from "../../assets/styles/Container";
import erro404 from "../../assets/imgs/404.svg";
import ArrowLeft from "../../assets/imgs/left_arrow.svg";
import {Link} from "react-router-dom"

export const Page404 = () => {
  return (
    <>
      <Container>
        <Page404Styled>
          <div className="card">
            <div className="btn">
              {/* <Button> */}
              <Link to={"/ultimas"}>
                  <img className="arrow-left" src={ArrowLeft} alt="Voltar" />
              </Link>
              {/* </Button> */}
            </div>
            <div className="text">
              <h1>Página não encontrada, carniça!</h1>
              <img src={erro404} alt="Erro 404" />
            </div>
          </div>
        </Page404Styled>
      </Container>
    </>
  );
};
